import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m26.94 16.8-1.74-1.739V10.8c0-.66-.54-1.2-1.2-1.2h-1.2c-.66 0-1.2.54-1.2 1.2v.664l-2.4-2.398c-.328-.31-.628-.666-1.2-.666s-.872.356-1.2.666L9.06 16.8c-.374.39-.66.674-.66 1.2 0 .676.518 1.2 1.2 1.2h1.2v7.2c0 .66.54 1.2 1.2 1.2h2.4a1.2 1.2 0 0 0 1.2-1.2v-4.8c0-.66.54-1.2 1.2-1.2h2.4c.66 0 1.2.54 1.2 1.2v4.8c0 .663-.063 1.2.6 1.2h3c.66 0 1.2-.54 1.2-1.2v-7.2h1.2c.682 0 1.2-.524 1.2-1.2 0-.526-.286-.81-.66-1.2Z",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }